import React from 'react';
import ReactDOM from 'react-dom/client';
//import reportWebVitals from './reportWebVitals';
import './index.css';
//import App from './App';
/*
import AppTfa from './2fa';
import AppTfa2 from './2fa/confirm';

import Cot from './cot';*/

//import MsmsApp from './msms';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';

//import { schoolAppTeacher } from './schoolapp/teacher';
//import { schoolAppPortal } from './schoolapp/portal';

//import Bank1 from './bank1';
//import HofA from './hofAdmin';
import K4dL from './k4dLanding';
//import K4dA, { k4dArouter } from './k4dAdmin';
//import K4dU, { k4dUrouter } from './k4dUser';
//import Snb from './snb';
//import ServiceProviderRouter from './serviceprovider';

//import BadgeApp from './badge';
const root = ReactDOM.createRoot(document.getElementById('root'));

//window.e=true;
//window.v=false;

//root.render(<BadgeApp />);

//root.render(<Snb />);
root.render(<K4dL />);

//root.render(<Bank1 />);
//root.render(<HofA />);
//root.render(<K4dA />);
//root.render(<K4dU />);
//root.render(<ServiceProviderApp />);
//root.render(<RouterProvider router={ServiceProviderRouter} />);
/*
root.render( 
    <RouterProvider router={schoolAppTeacher} />,
);
*/

/*
root.render(
  <React.StrictMode>
    <MsmsApp /> 
  </React.StrictMode>
);
*/

/*
if (window.e) {
root.render(
  <React.StrictMode>
    <AppTfa /> 
  </React.StrictMode>
);
}else if (window.v) {
root.render(
  <React.StrictMode>
    <AppTfa2 /> 
  </React.StrictMode>
);
}*/

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
